import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component";
import { AuthLayoutComponent } from "./shared/layout/app-layouts/auth-layout.component";
import { ModuleWithProviders } from "@angular/core";
import { AuthGuardService as AuthGuard } from './shared/services/auth-guard.service';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        data: { pageTitle: 'Login' },
        children: [
            { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
            //{ path: 'home', loadChildren: 'app/+home/home.module#HomeModule', data: { pageTitle: 'Home' } },
            { path: 'welcome', loadChildren: 'app/+welcome/welcome.module#WelcomeModule', data: { pageTitle: 'Welcome' }, canActivate: [AuthGuard] },
            { path: 'booking', loadChildren: 'app/+booking/booking.module#BookingModule', data: { pageTitle: 'Booking' }, canActivate: [AuthGuard] },
            { path: 'bookingwizard', loadChildren: 'app/+booking-wizard/booking-wizard.module#BookingWizardModule', data: { pageTitle: 'Booking Wizard' }, canActivate: [AuthGuard] },
            { path: 'success', loadChildren: 'app/+success/success.module#SuccessModule', data: { pageTitle: 'Success' }, canActivate: [AuthGuard] },
            { path: 'verifiedEmail', loadChildren: 'app/+verified-email/verified-email.module#VerifiedEmailModule', data: { pageTitle: 'Verified Email' } },
            { path: 'guest-booking', loadChildren: 'app/+guest-booking/guest-booking.module#GuestBookingModule', data: { pageTitle: 'Guest Booking' } },
            { path: 'saved-addresses', loadChildren: 'app/+saved-addresses/saved-addresses.module#SavedAddressesModule', data: { pageTitle: 'Saved Addresses' }, canActivate: [AuthGuard] },
            { path: 'confirmation', loadChildren: 'app/+guest-confirmation/guest-confirmation.module#GuestConfirmationModule', data: { pageTitle: 'confirmation' }}
        ]
    },

    { path: 'auth', component: MainLayoutComponent, loadChildren: 'app/+auth/auth.module#AuthModule' },

    { path: '**', redirectTo: 'home' }
    //
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });




// WEBPACK FOOTER //
// ./src/app/app.routing.ts